import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Tile } from '../partials';
import Slider from "react-slick";

let regions = [];
let ribbonData = {};
let vehicles = [];
const offerFilterDetails = window.offer_vehicle_filters ?? false;

class VehicleTiles extends Component {

    state = {
        vehicles: [],
        refs: []
    };

    constructor (props) {
        super(props);
        regions = props.regions;
        ribbonData = props.ribbonData;
        vehicles = props.vehicles;
        this.sliderRef = React.createRef();

    };

    componentDidMount() {

        let fetchUrl = '/api/v1/latestVehicles'; //'api/v1/vehicles';

        if (window.is_latest_vehicles) {
            fetchUrl = '/content/json/newarrivals.json';
        }

        if (window.is_make_page) {
            fetchUrl = `/api/v1/latestVehiclesByMake/${window.use_make}`;
        }

        if (window.is_electric_vehicles) {
            fetchUrl = `/api/v1/latestVehiclesByFuel/${window.use_fuel}`;
        }

        if (window.is_vehicle_page) {
            let vehicle = {
                dealer: window.current_vehicle['@BODY_SEQ'] || false,
                yard : window.current_vehicle['@BODY_YARD_SEQ'] || false,
                make: window.use_make || false,
                id:  window.current_vehicle['@LISTING_SEQ'] || false,
                bodytype: window.current_vehicle['@LISTING_BODY_TYPE'] || false,
                model: window.current_vehicle['@LISTING_MODEL'] || false,
                year :window.current_vehicle['@LISTING_YEAR'] || false,
                currentPrice: window.use_price || false,
            }
            let queryString = new URLSearchParams(vehicle).toString();

            fetchUrl = `/api/v1/getRelatedVehicles?${queryString}`;
        }

        if (window.is_dealer_page) {
            fetchUrl = `/api/v1/latestVehiclesByDealer/${window.use_dealer}`;
        }

        const stringExtra = "/options"
        const fetchRibbonUrl = `/api/v1/getOptions` + stringExtra;


        if(window.is_regional_dealership){
            let stringExtra =  "/"
            window.regional_dealerships_ids.forEach((id) =>{
                stringExtra += id + "_";
            });

            fetchUrl = `/api/v1/latestVehiclesByDealers` + stringExtra;

        }

        if(offerFilterDetails){
            let queryString = new URLSearchParams(offerFilterDetails).toString();
            fetchUrl = `/api/v1/getFilteredVehicles?${queryString}`;
        }

        fetch(`${fetchUrl}`)
        .then((res) => res.json())
            .then((data) => {
            this.setState({
                vehicles: data,
                refs: data.map(() => {return React.createRef()})
            }, function () {

                const { left, right, frame, list, slider } = this.props;

                if (this.props.left) {
                    this.props.left.addEventListener('click', this.handlePrev);
                }
                if (this.props.right) {
                    this.props.right.addEventListener('click', this.handleNext);
                }
            })
        })
        .catch((err) => console.log(err))

    };
    handlePrev = () => {
        if (this.sliderRef.current) {
            this.sliderRef.current.slickPrev();
        }
    };

    handleNext = () => {
        if (this.sliderRef.current) {
            this.sliderRef.current.slickNext();
        }
    };

    renderItem = (item, index) => {
        return (
            <div className={`vehicle-tiles__item`} key={index} ref={this.state.refs[index]}>
                <Tile {...item} regions={regions} ribbonData={ribbonData}/>
            </div>
        );
    }

    render() {

        return (
            <Fragment>
                {offerFilterDetails && (
                    <p className={`vehicle-tiles__resultsfound`}>Results found: {this.state.vehicles.length} vehicles</p>
                )}
                <Slider
                    dots={false}
                    infinite={false}
                    speed={500}
                    slidesToShow={4.25}
                    slidesToScroll={4}
                    ref={this.sliderRef}
                    responsive={[ {
                        breakpoint: 1024, // example: tablets or small laptops
                            settings: {
                                slidesToShow: 3.25,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 768, // mobile and tablets
                            settings: {
                                slidesToShow: 2.25,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 480, // smaller phones
                            settings: {
                                slidesToShow: 1.25, // a bit of the next card visible
                                slidesToScroll: 1,
                            },
                        },
                    ]}
                >
                    {this.state.vehicles.length > 0 ? this.state.vehicles.map(this.renderItem) : null }
                </Slider>
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<VehicleTiles {...props} />, el)
}
